import { date_timezone_compensated } from "./kpi";

export const horizonalLinePlugin = {
    afterDraw: function(chartInstance: { scales: { [x: string]: any; }; chart: any; options: { horizontalLine: string | any[]; }; }) {
        var yScale = chartInstance.scales["y-axis-1"];
        var canvas = chartInstance.chart;
        var ctx = canvas.ctx;
        var index;
        var line;
        var style;
        var yValue;
    
        if (chartInstance.options.horizontalLine) {
            for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
                line = chartInstance.options.horizontalLine[index];
        
                if (!line.style) {
                    style = "rgba(169,169,169, .6)";
                } else {
                    style = line.style;
                }
        
                if (line.y) {
                    yValue = yScale.getPixelForValue(line.y);
                } else {
                    yValue = 0;
                }
        
                ctx.lineWidth = 3;
        
                if (yValue) {
                    ctx.beginPath();
                    // Small x shift to avoid hiding y-axis graduation
                    ctx.moveTo(56, yValue);
                    ctx.lineTo(canvas.width - 40, yValue);
                    ctx.strokeStyle = style;
                    ctx.stroke();
                }
        
                if (line.text) {
                    ctx.fillStyle = style;
                    // Small x shift to avoid hiding y-axis graduation
                    ctx.fillText(line.text, 60, yValue - 6);
                }
            }
            return;
        };
    }
};

export const VerticalLinePlugin = {
    afterDatasetDraw: function (chart: any, params: any) {
        // Only draw after animation has finished and is the desired dataset
        try {
            // if (params.easingValue !== 0 && params.meta.type === "scatter") {
            if (params.easingValue === 1 && params.meta.type === "scatter") {
                var ctx = chart.ctx;
                ctx.save();
                // console.log("params.easingValue", params.easingValue)
                params.meta.data.forEach((point: any) => {
                    var model = point._model;
                    // console.log("model.y", model.y)
                    ctx.strokeStyle = point._options.borderColor;
                    ctx.lineWidth = point._options.borderWidth;
                    ctx.beginPath();
                    // ctx.moveTo(model.x, (model.y * params.easingValue ));
                    ctx.moveTo(model.x, model.y);
                    // ctx.lineTo(model.x, chart.chartArea.bottom);
                    ctx.lineTo(model.x, chart.chartArea.bottom);
                    ctx.stroke();
                });
                ctx.restore();
            }
        }
        catch (e) {

        }
    }
};


export const drawPlugin = {
    afterDatasetDraw: function (chart: any, args: any, options: any) {
        args.meta.data.forEach(function (element: any) {
            var borderWidth = 2;
            var ctx = chart.ctx;
            var vm = element._view;
            var half = vm.width / 2;
            var left = vm.x;
            var right = vm.x + half;
            var top = vm.y;
            var width = vm.width;
            var height = vm.height;
            var bottom = top - height;
            ctx.beginPath();
            ctx.lineWidth = borderWidth;
            ctx.strokeStyle = vm.borderColor;
            ctx.setLineDash([5, 5]);
            ctx.moveTo(left, top);
            ctx.lineTo(left, top + height);
            /*ctx.moveTo(left, top);
            ctx.lineTo(left + width, top);*/
            ctx.moveTo(left + width, top);
            ctx.lineTo(left + width, top + height);

            ctx.stroke();
            ctx.save();
        });
    }
}

 
export const default_options = {
    responsive: true,
    maintainAspectRatio: false,

    legend: {
        display: true,
        position: 'bottom'
    },
    scales: {
        xAxes: {
            type: 'time',
            ticks: {
                autoSkip: true,
                maxTicksLimit: 9,
                maxRotation: 0,
                minRotation: 0,
            },
            time: {
                unit: 'hour',
                minUnit: 'second',
                displayFormats: {
                    hour: 'YYYY-MM-DDTHH:mm',
                    second: 'YYYY-MM-DDTHH:mm:ss'
                },
            },
        },
        yAxes: {
            scaleLabel: {
                display: true,
                fontFamily: 'sans-serif',
                fontSize: '14',
                fontStyle: 'italic'
            }
        },
    },
} 



// export const complete_bar_data = (dataset:Array<any>, value:string, min:string, max:string) =>{
//     if(!dataset) return [];
//     try{
//         let start:any, stop:any;
//         if(dataset[0]){
//             start = {
//                 x: dataset[0][value],
//                 y: date_timezone_compensated(min)
//             }
//         }
//         if(dataset[dataset.length]){
//             stop = {
//                 x: dataset[dataset.length-1][value],
//                 y: date_timezone_compensated(max)
//             }
//         }
//         return [
//             start,
//             ...dataset,
//             stop
//         ]
//     }
//     catch(e){
//         console.error('complete bar data', e);
//         return []
//     }
// }
export const complete_bar_data_start = (dataset:Array<any>, value:string, min:string) =>{
    if(!dataset) return {};
    try{
        if(dataset.length > 0){
            let v ={
                y: dataset[dataset.length - 1][value],
                x: date_timezone_compensated(min)
            }
            console.log("v min",v);
            return v
        }
    }
    catch(e){
        console.error('complete bar data start', e);
        return {}
    }
}
export const complete_bar_data_stop = (dataset:Array<any>, value:string, max:string) =>{
    if(!dataset) return null;
    try{
        if(dataset.length > 0){
            let v ={
                y: dataset[0][value],
                x: max
                // x: date_timezone_compensated(max)
            }
            console.log("v max",v);
            return v 
        }
    }
    catch(e){
        console.error('complete bar data stop', e);
        return null
    }
}